import { useContext } from 'react'
import { OverlayCtx, OverlayVisCtx } from './OverlayContext'

export const useOverlay = () => useContext(OverlayCtx)
export const useAppOverlayVis = () => useContext(OverlayVisCtx)
